export default __webpack_public_path__ + "static/logo-cuatrotorres-v2-2e74d59ce841f0d22cd7f4e73e7b4f37.png";